export function clamp(num: number, min: number, max: number): number {
  return Math.min(Math.max(num, min), max);
}

export function roundNumber(value: number, scale: number): number {
  if (scale === 0) {
    return 0;
  }

  return Math.round(value * scale) / scale;
}

export function getRatio(curr: number, total: number): number | undefined {
  if (total === 0) {
    return undefined;
  }

  return (curr * 100) / total;
}
